import React from "react";

const About = () => {
  return (
    <div className="col-about">
      <div className="profile-div">
        <div className="profile-id">
          <img
            className="profile-pic"
            width="75px"
            height="75px"
            src="./db.jpg"
            alt="profile pic"
          ></img>
          <h4 className="profile-name">David Bergendorff</h4>
        </div>

        <p className="profile-text">
          "I have worked mainly on particle effects and most of my work was on
          the visuals and mechanics of the earth wall and the visuals of the air
          effect. I have also developed this website as well as our demo reel
          and making of-video."{" "}
        </p>
      </div>
      <div className="profile-div">
        <div className="profile-id">
          <img
            className="profile-pic"
            width="75px"
            height="75px"
            src="./blank-profile-pic.png"
            alt="profile pic"
          ></img>
          <h4 className="profile-name">Jonas Lundin</h4>
        </div>

        <p className="profile-text">
          "I worked on the water element, grass/wind interaction and sound
          effects. I also collaborated on the wind element."
        </p>
      </div>
      <div className="profile-div">
        <div className="profile-id">
          <img
            className="profile-pic"
            width="75px"
            height="75px"
            src="./dr.jpg"
            alt="profile pic"
          ></img>
          <h4 className="profile-name">David Ryan</h4>
        </div>

        <p className="profile-text">
          "I spent a lot of time making sure all of our features worked well
          both with the VR headset and with each other, and tweaking them when
          they didn't. In order to enable capture of large motions and making
          them trigger certain elemental powers, I developed a system to log
          motion, and keep track of which motions could or could not fulfil the
          conditions of different powers. Both the earth wall power and the fire
          missile depend on this system. In terms of graphics, I assisted Jonas
          with the effect making grass sway in response to the wind power. More
          significantly, I also implemented the effects for the fire missile,
          both its trail and it's explosion effect, although the methods used
          were not of my own design."
        </p>
      </div>
      <div className="profile-div">
        <div className="profile-id">
          <img
            className="profile-pic"
            width="75px"
            height="75px"
            src="./blank-profile-pic.png"
            alt="profile pic"
          ></img>
          <h4 className="profile-name">Joel Olbe</h4>
        </div>

        <p className="profile-text">
          "I worked on the enemies, the environment and a bit with the player’s
          abilities. Mainly how they interact with each other through
          pathfinding and collisions."
        </p>
      </div>
    </div>
  );
};

export default About;
